import styled from 'styled-components';

export const Container = styled.nav`
  align-items: center;
  display: flex;
  gap: 4rem;

  button {
    font-size: ${({ theme }) => theme.font.size.md};
    height: 39px;
    width: 124px;
  }
`;
